import React from 'react';
import {messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {Button} from '@deviceinsight/ng-ui-basic-components';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/free-solid-svg-icons';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	clientId: string;
};

const ClientIdComponent = ({clientId}: Props) => {
	const copyClientId = (clientId: string) => {
		navigator.clipboard.writeText(clientId);
		messageBoxSuccess(<Trans i18nKey="kisapi.credentials.customerIdCopied">The customer id was copied</Trans>);
	};

	return (
		<span>
			<input style={{border: 0}} size={40} value={clientId} data-testid={`clientId-${clientId}`} readOnly></input>
			<Button naked onClick={() => copyClientId(clientId)} style={{height: 20, width: 20, paddingLeft: 4}}>
				<FontAwesomeIcon icon={faCopy} size={'lg'} />
			</Button>
		</span>
	);
};

export default ClientIdComponent;
